import axios from "axios";
import { Base_URL } from "../../url";
import { toast } from "react-toastify";



export const fetchCRMLeads = async () => {
  try {
    const response = await axios.get(`${Base_URL}/Lead/GetAllLeads`);
    // console.log(response);
    return response.data;
  } catch (error) {
    throw error.response?.data || "Error At Fetching Data!";
  }
};